The interval the remuneration amounts are calculated over.

Currently three interval codes are defined:

- `Hour` is used to express hourly rates.
- `Month` is used to express monthly salaries.
- `Year` is used to express annual salaries.

The specified value must correspond to `RemunerationPackageInput.basisCode`:

- When `RemunerationPackageInput.basisCode` equals `Hourly`, the `RemunerationRangeInput.intervalCode` must be `Hour`.

- When `RemunerationPackageInput.basisCode` equals `Salaried`, the `RemunerationRangeInput.intervalCode` must be `Month` or `Year`.

- When `RemunerationPackageInput.basisCode` equals `SalariedPlusCommission`, the `RemunerationRangeInput.intervalCode` must be `Year`.
